import type {
  ConvertQueryInvalidateProps,
  ConvertQueryInvalidateTargetProps,
  QueryInvalidateTarget,
} from "./query-invalidate.type";
import type { QueryKey } from "@tanstack/react-query";

import { isDefined } from "@/utilities/defined";

export const getQueryInvalidateKeys = (
  invalidate?: QueryInvalidateTarget[]
) => {
  const backgroundKeys: QueryKey[] = [];
  const awaitedKeys: QueryKey[] = [];

  invalidate?.forEach(({ mode, queryKey }) => {
    if (mode === "background") backgroundKeys.push(queryKey);
    else awaitedKeys.push(queryKey);
  });

  return {
    backgroundKeys,
    awaitedKeys,
  };
};

export const convertQueryInvalidate = <Key extends string>({
  invalidate,
  getCustomQueryKey,
}: ConvertQueryInvalidateProps<Key>): QueryInvalidateTarget[] => {
  return invalidate
    .map((target) =>
      convertQueryInvalidateTarget({ target, getCustomQueryKey })
    )
    .filter(isDefined);
};

export const convertQueryInvalidateTarget = <Key extends string>({
  target,
  getCustomQueryKey,
}: ConvertQueryInvalidateTargetProps<Key>):
  QueryInvalidateTarget | undefined => {
  if ("queryKey" in target) return target;

  const queryKey = getCustomQueryKey(target.key);
  if (queryKey) return { queryKey, mode: target.mode };

  return undefined;
};
